import type { FC } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  Button,
  Typography,
  Stack,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"

import SegSvg from "@/UDTreat/assets/modelcheck/seg.svg"
import SegClickSvg from "@/UDTreat/assets/modelcheck/seg_click.svg"
import LableSvg from "@/UDTreat/assets/modelcheck/lable.svg"
import LableClickSvg from "@/UDTreat/assets/modelcheck/lable_click.svg"
import BiteSvg from "@/UDTreat/assets/modelcheck/bitereg.svg"
import BiteClickSvg from "@/UDTreat/assets/modelcheck/bitereg_click.svg"
import SpaceSvg from "@/UDTreat/assets/modelcheck/spacing.svg"
import SpaceClickSvg from "@/UDTreat/assets/modelcheck/spacing_click.svg"
import OrientationSvg from "@/UDTreat/assets/modelcheck/orientation.svg"
import OrientationClickSvg from "@/UDTreat/assets/modelcheck/orientation_click.svg"

const AutoModelCheck: FC = () => {
  const dispatch = useAppDispatch()
  const { autoModelCheckStep } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const stepTmp = [
    {
      id: "check-segmentation",
      label: "Check Segmentation",
      icon: SegSvg,
      activeIcon: SegClickSvg,
      index: 0,
    },
    {
      id: "check-label",
      label: "Check Label",
      icon: LableSvg,
      activeIcon: LableClickSvg,
      index: 1,
    },
    {
      id: "check-bitereg",
      label: "CheckBite Registration",
      icon: BiteSvg,
      activeIcon: BiteClickSvg,
      index: 2,
    },
    {
      id: "check-space",
      label: "Check Space",
      icon: SpaceSvg,
      activeIcon: SpaceClickSvg,
      index: 3,
    },
    {
      id: "adjust-orientation",
      label: "Check Orientation",
      icon: OrientationSvg,
      activeIcon: OrientationClickSvg,
      index: 4,
    },
  ]

  const { t } = useTranslation("common")

  return (
<>
 <Stack
      direction={"column"}
      spacing={2}
      sx={{
        width: "35%",
        transform: "translate(0px, -10px)",
        justifyContent: "flex-end",
      }}
    >
      {/* <Typography
        sx={{
          color: "#FFF",
          fontSize: 30,
          textAlign: "center",
        }}
      >
        {stepTmp[autoModelCheckStep].label}
      </Typography> */}
      <Stepper activeStep={autoModelCheckStep} orientation="horizontal">
        {stepTmp.map((i) => (
          <Step key={i.id}>
            <StepLabel
              icon={
                <ReactSVG
                  src={i.index === autoModelCheckStep ? i.activeIcon : i.icon}
                  style={{
                    width: 24,
                    height: 24,
                    display: "block",
                  }}
                />
              }
            >
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
</>
   
  )
}
export default AutoModelCheck
